import { UseQueryOptions } from '@tanstack/react-query';
import { CustomersQuery, useCustomersQuery } from '../api/gql';

type Props = {
  queryOptions?: UseQueryOptions<CustomersQuery>;
};

export const useCustomerLookup = (props?: Props) => {
  const { data, status, isLoading } = useCustomersQuery(undefined, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...props?.queryOptions,
  });

  const lookupCustomerByVatId = (vatId: string) => data?.customers.find((customer) => customer.vatId === vatId);

  return {
    data,
    isLoading,
    isReady: status === 'success',
    lookupCustomerByVatId,
  };
};
